import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const BackupCodesSuccessContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const BackupCodesSuccessIcon = styled(Box)(() => ({
  width: "120px",
  height: "120px",
  marginBottom: "32px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const BackupCodesSuccessTitle = styled(Typography)(() => ({
  fontSize: "26px",
  fontStyle: "normal",
  fontWeight: 600,
  textAlign: "center",
  marginBottom: "16px",
  color: "#1B252F",
}));

export const BackupCodesSuccessSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: "center",
  fontFamily: "Nunito",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "24px",
  marginBottom: "44px",
  whiteSpace: "pre-line",
}));

export const BackupCodesSuccessActions = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));
